// ThemeProvider.tsx
import React, { createContext, useState, useContext, useEffect } from 'react';

type ThemeContextType = {
    theme: string;
    setTheme: (newTheme: string) => void;
};

const ThemeContext = createContext<ThemeContextType>({
    theme: 'theme-light',
    setTheme: (newTheme: string) => {
        console.warn("No provider found. Attempted to set theme to:", newTheme);
    },
});


export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // 1. Leer el tema guardado en localStorage o usar “theme-light” por defecto
    const storedTheme = localStorage.getItem('userTheme') || 'theme-light';

    // 2. Guardar ese estado en un useState
    const [theme, setThemeState] = useState(storedTheme);

    // 3. Al cambiar el tema, guardarlo en localStorage
    const setTheme = (newTheme: string) => {
        setThemeState(newTheme);
        localStorage.setItem('userTheme', newTheme);
    };

    // 4. useEffect para quitar y poner la clase al `<html>` con el tema actual
    useEffect(() => {
        document.documentElement.classList.remove('theme-light', 'theme-dark', 'theme-pastel');
        document.documentElement.classList.add(theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
